<template>
  <v-row v-if="reRenderComponent">
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="users"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.user')"
        v-model="form.userId"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="projects"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.project')"
        v-model="form.projectId"
        @change="handleChangeProject"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="filteredApiEndpoints"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.api')"
        v-model="form.apiEndpointId"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="httpMethods"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.method')"
        v-model="form.httpMethodCode"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="httpStatuses"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.http-status')"
        v-model="form.httpStatusCode"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="responseTimeRanges"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('request-logs.search.form.response-time')"
        v-model="form.responseTimeCode"
      ></v-autocomplete>
    </v-col>

    <v-col sm="6" md="4" cols="12" class="mb-3">
      <d-date-picker
        :label="$t('request-logs.search.form.from-date')"
        hide-details="auto"
        filled
        v-model="form.fromDate"
        :maxDate="maxFromDate"
      ></d-date-picker>
    </v-col>

    <v-col sm="6" md="4" cols="12" class="mb-3">
      <d-date-picker
        :label="$t('request-logs.search.form.to-date')"
        hide-details="auto"
        filled
        v-model="form.toDate"
        :maxDate="maxToDate"
        :minDate="form.fromDate"
      ></d-date-picker>
    </v-col>
  </v-row>
</template>
<script>
import { getRequestLogSearchParams } from "@/services/request";
import { format, parseISO, compareAsc } from "date-fns";

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      form: null,
      projects: [],
      apiEndpoints: [],
      users: [],
      httpMethods: [],
      httpStatuses: [],
      responseTimeRanges: [],
      reRenderComponent: true,
    };
  },
  computed: {
    maxToDate() {
      return format(new Date(), "yyyy-MM-dd");
    },
    maxFromDate() {
      return this.form?.toDate
        ? format(parseISO(this.form?.toDate), "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd");
    },
    filteredApiEndpoints() {
      return this.form.projectId
        ? this.apiEndpoints.filter((api) => api.groupId == this.form.projectId)
        : this.apiEndpoints;
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    "form.fromDate": {
      handler(val) {
        if (
          this.form.toDate &&
          compareAsc(parseISO(val), parseISO(this.form.toDate)) == 1
        ) {
          this.form.toDate = null;

          this.reRenderComponent = false;
          this.$nextTick(() => {
            this.reRenderComponent = true;
          });
        }
      },
    },
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleChangeProject() {
      const isApiInFilteredItems = this.filteredApiEndpoints.find(
        (api) => api.value == this.form.apiEndpointId
      );

      if (!isApiInFilteredItems) {
        this.form.apiEndpointId = null;
      }
    },
  },
  async created() {
    const {
      projects,
      apiEndpoints,
      users,
      httpMethods,
      httpStatuses,
      responseTimeRanges,
    } = await getRequestLogSearchParams();

    this.projects = projects;
    this.apiEndpoints = apiEndpoints;
    this.users = users;
    this.httpMethods = httpMethods;
    this.httpStatuses = httpStatuses;
    this.responseTimeRanges = responseTimeRanges;
  },
};
</script>
